import { Fragment } from 'react';

import AdBanner from '@/components/AdBanner';
import DayInfo from '@/components/quartered-forecast/DayInfo';
import { BannerEnum } from '@/data/banners';
import { QuarteredForecast } from '@/models/QuarteredForecast';
import { AppConfig } from '@/utils/AppConfig';
import { isDatePast } from '@/utils/DateUtils';

type QuarteredForecastWidgetProps = {
  quarteredForecast: QuarteredForecast[];
};

const QuarteredForecastWidget = ({ quarteredForecast }: QuarteredForecastWidgetProps) => {
  const firstInContentBanner = AppConfig.partner.banners[BannerEnum.FIRST_IN_CONTENT];
  const secondInContentBanner = AppConfig.partner.banners[BannerEnum.SECOND_IN_CONTENT];

  return (
    <div className="my-6 text-grey-900 lg:my-14">
      <h2 className="mb-4 px-4 text-xl font-medium lg:mb-5 lg:px-0 lg:text-2xl xl:text-2.5xl">
        Прогноз погоды на 10 дней
      </h2>
      {/* {days} */}
      {quarteredForecast
        .filter((day) => !isDatePast(day.date, AppConfig.serverDate))
        .map((day, index) => {
          return (
            <Fragment key={day.date.getTime()}>
              <DayInfo dayInfo={day} openByDefault={index === 0} />
              {AppConfig.partner.isDvHab() && index === 0 && (
                <AdBanner
                  dataId={firstInContentBanner.id}
                  // eslint-disable-next-line tailwindcss/no-custom-classname
                  className={`max-w-[${firstInContentBanner.width}] my-4 mx-auto overflow-hidden`}
                />
              )}
              {AppConfig.partner.isDvHab() && index === 3 && (
                <AdBanner
                  dataId={secondInContentBanner.id}
                  // eslint-disable-next-line tailwindcss/no-custom-classname
                  className={`max-w-[${secondInContentBanner.width}] my-4 mx-auto overflow-hidden`}
                />
              )}
            </Fragment>
          );
        })}
    </div>
  );
};

export default QuarteredForecastWidget;
